import type { ReportExplorerConfiguration } from '../reportExplorer/model';
import { reportRequestsToExplorerConfiguration } from '../reportExplorer/reportConfiguration';
import { deserializeReportExplorerFilters } from '../reportExplorer/reportFilters';
import type { SavedReportConfig } from './model';

export function savedReportToExplorerConfiguration(
  savedReport: SavedReportConfig,
): ReportExplorerConfiguration {
  const configuration = reportRequestsToExplorerConfiguration(
    savedReport.report,
    savedReport.chartReport,
  );
  const { reportFilters, passthroughFilters } = deserializeReportExplorerFilters(
    savedReport.report.filters,
    savedReport.settings.filterValueLabels,
  );

  return {
    ...configuration,
    reportFilters,
    passthroughFilters,
  };
}
